var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// React
import React from 'react';
// Material ui
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem/MenuItem';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField/TextField';
// Helper
import { mobileAndTabletcheck } from '../../helpers/MobileHerper';
var SelectForm = function (props) {
    /** Component properties */
    var initialValue = props.initialValue, options = props.options, id = props.id, label = props.label, error = props.error, required = props.required, helperText = props.helperText, onChange = props.onChange, onUnMount = props.onUnMount, reset = props.reset, visible = props.visible;
    /** Component state */
    var _a = React.useState(initialValue), value = _a[0], setValue = _a[1];
    var _b = React.useState(options), selectOptions = _b[0], setSelectOptions = _b[1];
    React.useEffect(function () {
        return function () {
            if (onUnMount) {
                onUnMount();
            }
        };
    }, [onUnMount]);
    React.useEffect(function () {
        if (reset || !visible) {
            setValue('');
        }
    }, [reset, visible]);
    React.useEffect(function () {
        if (JSON.stringify(selectOptions.sort()) !== JSON.stringify(options.sort())) {
            setSelectOptions(options);
        }
    }, [options]);
    /**
     * Handle select change
     */
    var handleSelectChange = function (evt) {
        evt.persist();
        var newValue = evt.target.value;
        setValue(newValue);
        onChange('keyValue', [id, newValue]);
    };
    var defaultProps = { id: id, label: label, options: selectOptions, error: error, helperText: helperText, required: required, value: value, onChange: handleSelectChange };
    return props.visible
        ? mobileAndTabletcheck()
            ? React.createElement(WrappedSelectNative, __assign({}, defaultProps))
            : React.createElement(WrappedSelect, __assign({}, defaultProps))
        : null;
};
/**
 * Wrapper select component
 * @param props
 */
var WrappedSelect = function (props) { return (React.createElement(TextField, __assign({}, props, { select: true, margin: "normal", fullWidth: true }), props.options.map(function (option, index) { return (React.createElement(MenuItem, { key: "" + option.value + index, value: option.value }, option.label)); }))); };
/**
 * Wrapped native select
 * @param props
 */
var WrappedSelectNative = function (props) {
    var selectProps = getSelectProps(props);
    return (React.createElement(FormControl, { fullWidth: true, margin: "normal", error: props.error },
        React.createElement(InputLabel, { htmlFor: props.id }, props.label),
        React.createElement(Select, __assign({}, selectProps, { native: true, inputProps: { id: props.id } }),
            React.createElement("option", { value: "" }),
            props.options.map(function (option) { return (React.createElement("option", { value: option.value, key: option.value }, option.label)); })),
        props.error
            ? React.createElement(FormHelperText, null, props.helperText)
            : null));
};
var getSelectProps = function (props) {
    var propsKey = Object.keys(props);
    var excludeProps = ['error', 'helperText'];
    return propsKey.reduce(function (selectProps, propName) {
        var _a;
        return !excludeProps.includes(propName) ? __assign(__assign({}, selectProps), (_a = {}, _a[propName] = props[propName], _a)) : selectProps;
    }, {});
};
export default SelectForm;
//# sourceMappingURL=index.js.map